/**
* Bug #730
* @Author Liya Baby
* @Date 26 January 2022
*/
import axios from "axios";
import { API_RESEND_OTP, API_VERIFY_OTP } from "./endpoint";

export const otpSubmit = (data) => {
    return axios.post(API_VERIFY_OTP, data);
  };

  export const resendOtp = (transCode) => {
    return axios.get(API_RESEND_OTP, {
      params: {
        transCode :transCode
      }
    });
  };
  